import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { AuthComponent } from './features/auth/auth.component';
import { AuthorAnalyticsComponent } from './features/author-analytics/author-analytics.component';
import { AuthGuard } from './core/guards/auth.guard';
// Import the CampaignAnalyticsComponent
import { CampaignPerformanceComponent } from './features/campaign/campaign-performance/campaign-performance.component';
import { ArticlesComponent } from './features/articles/articles.component';
import { HumCampaignsComponent } from './features/campaign/hum-campaigns/hum-campaigns.component';
// Correct route paths
export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'author-analytics', component: AuthorAnalyticsComponent },
      { path: 'campaign-performance', component: CampaignPerformanceComponent },
      { path: 'hum-campaigns', component: HumCampaignsComponent },
      {
        path: 'aet-funnel',
        loadComponent: () => import('./features/aet-funnel/aet-funnel.component').then(m => m.AetFunnelComponent)
      },
      {
        path: 'article-details',
        loadComponent: () => import('./features/articles/articles.component').then(m => m.ArticlesComponent)
      },
      {
        path: 'article-usage',
        loadComponent: () => import('./features/articles/article-usage.component').then(m => m.ArticleUsageComponent)
      },
      {
        path: 'journal-dashboard',
        loadComponent: () => import('./features/journal-dashboard/journal-dashboard.component').then(m => m.JournalDashboardComponent)
      },
      {
        path: 'institution-unified',
        loadComponent: () => import('./features/institutions/institution-unified.component').then(m => m.InstitutionUnifiedComponent)
      },
      // Institution routes
      {
        path: 'institutions',
        loadComponent: () => import('./features/institutions/institution.component').then(m => m.InstitutionComponent)
      },
      {
        path: 'institutions/publishing',
        loadComponent: () => import('./features/institutions/publishing/publishing-analytics.component').then(m => m.PublishingAnalyticsComponent)
      },
      {
        path: 'institutions/reading-engagement',
        loadComponent: () => import('./features/institutions/reading/reading-engagement-analytics.component').then(m => m.ReadingEngagementAnalyticsComponent)
      },
      {
        path: 'institutions/people',
        loadComponent: () => import('./features/institutions/people/people-collaboration.component').then(m => m.PeopleCollaborationComponent)
      },
      {
        path: 'institutions/reports',
        loadComponent: () => import('./features/institutions/reports/reports-analytics.component').then(m => m.ReportsAnalyticsComponent)
      },
      {
        path: 'profile-analytics',
        loadComponent: () => import('./features/profile-analytics/profile-analytics.component').then(m => m.ProfileAnalyticsComponent)
      },
      {
        path: 'sales-lead-lookup',
        loadComponent: () => import('./features/sales-lead-lookup/sales-lead-lookup.component').then(m => m.SalesLeadLookupComponent)
      },
      {
        path: 'author-contact',
        loadComponent: () => import('./features/author-contact/author-contact.component').then(m => m.AuthorContactComponent)
      },
      {
        path: 'thesaurus-lookup',
        loadComponent: () => import('./features/thesaurus-lookup/thesaurus-lookup.component').then(m => m.ThesaurusLookupComponent)
      },
      {
        path: 'term-count',
        loadComponent: () => import('./features/term-count/term-count.component').then(m => m.TermCountComponent)
      },
      {
        path: 'lead-evaluation',
        loadComponent: () => import('./features/lead-evaluation/lead-evaluation.component').then(m => m.LeadEvaluationComponent)
      },
      // Add other routes
    ]
  },
  { path: 'auth/login', component: AuthComponent },
  { path: '**', redirectTo: '' }
]; 